<template>
  <div class="call-log-summary">
    <div class="summary-item">
      <h4>{{ totalCalls }}</h4>
      <p>{{ $t('CALL_LOG_REPORT.SUMMARY.TOTAL_CALLS') }}</p>
    </div>

    <div class="summary-item">
      <h4>{{ inboundCalls }}</h4>
      <p>{{ $t('CALL_LOG_REPORT.SUMMARY.INBOUND_CALLS') }}</p>
    </div>

    <div class="summary-item">
      <h4>{{ outboundCalls }}</h4>
      <p>{{ $t('CALL_LOG_REPORT.SUMMARY.OUTBOUND_CALLS') }}</p>
    </div>

    <div class="summary-item">
      <h4>{{ answeredCalls }}</h4>
      <p>{{ $t('CALL_LOG_REPORT.SUMMARY.ANSWERED_CALLS') }}</p>
    </div>

    <div class="summary-item">
      <h4>{{ missedCalls }}</h4>
      <p>{{ $t('CALL_LOG_REPORT.SUMMARY.MISSED_CALLS') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    callLogs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totalCalls() {
      return this.callLogs.length;
    },
    inboundCalls() {
      return this.callLogs.filter(call => call.call_type === 'inbound').length;
    },
    outboundCalls() {
      return this.callLogs.filter(call => call.call_type === 'outbound').length;
    },
    answeredCalls() {
      return this.callLogs.filter(call => call.call_status === 'completed').length;
    },
    missedCalls() {
      return this.callLogs.filter(call => call.call_status === 'failed').length;
    },
  },
};
</script>

<style scoped>
.call-log-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 20px;
  margin-bottom: 16px;
}

.summary-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.summary-item h4 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.summary-item p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #555;
}
</style>